import { environment } from 'src/environments/environment';

export const APP_VERSION_POST = environment.apiUrl + '/admin/app-versions';
export const APP_VERSION_GET = environment.apiUrl + '/admin/app-versions';
